<template>
  <div>
    <pin-entry v-bind:length="4" v-model="pin" />
  </div>
</template>
<script>
import PinEntry from "@/components/pin-entry/index";

export default {
  components: { PinEntry },
  data() {
    return {
      pin: null,
    };
  },
};
</script>
